
<div class="MapLegend">
	<div v-if="showRouteColor" class="MapLegend__item">
		<span class="MapLegend__marker" :style="{ backgroundColor: routeColor }"></span>
		<span>Kolor markera: trasa</span>
	</div>
	<div v-if="showUserBadge" class="MapLegend__item">
		<span class="MapLegend__badge">SK</span>
		<span>Badge: użytkownik</span>
	</div>
	<div v-if="showPermanentPoint" class="MapLegend__item">
		<span class="MapLegend__marker MapLegend__marker--permanent">★</span>
		<span>Żółte oznaczenie: punkt stały</span>
	</div>
	<div v-if="showSelected" class="MapLegend__item">
		<span class="MapLegend__marker MapLegend__marker--selected">✓</span>
		<span>Zaznaczenie: punkt wybrany</span>
	</div>
</div>
